import { render } from "./CollapsibleSection.vue?vue&type=template&id=3e607b00&scoped=true"
import script from "./CollapsibleSection.vue?vue&type=script&lang=js"
export * from "./CollapsibleSection.vue?vue&type=script&lang=js"

import "./CollapsibleSection.vue?vue&type=style&index=0&id=3e607b00&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e607b00"]])

export default __exports__